// Seletor de veículo: cascata Marca → Modelo → Ano (modelo sem anos pula o ano) + "Meu veículo não
// está na lista" → formulário fora do catálogo. Liga todo [data-ds-seletor] da página.
// ARMADILHA conhecida do tema atual: abrir o <dialog> por código não carregava as marcas. Aqui o
// dataset é baixado na primeira interação REAL (mouse por cima, foco, toque, clique que abre a gaveta)
// e a variante 'page' já carrega ao abrir a página.
// Com ?ds_debug, cada etapa aparece na caixa do ArpineDS.etapa (ds-head.liquid): diagnóstico do iPhone.
const etapa = (texto) => window.ArpineDS.etapa?.(`seletor: ${texto}`);
if (window.ArpineDS.debug) {
  // registrados antes das importações: aparecem mesmo se o módulo travar nelas
  const campo = (el) => el?.closest?.("[data-ds-seletor] select");
  const descreve = (s) => `${s.closest("[data-ds-seletor]").dataset.variant} ${s.name}: ${s.options.length} opções${s.disabled ? ", desligado" : ""}`;
  for (const tipo of ["touchstart", "focusin"]) {
    document.addEventListener(tipo, (e) => { const s = campo(e.target); if (s) etapa(`${tipo} em ${descreve(s)}`); }, true);
  }
  document.addEventListener("change", (e) => { const s = campo(e.target); if (s) etapa(`escolheu ${s.name} = "${s.value}"`); }, true);
  document.addEventListener("click", (e) => { if (e.target.closest?.('[data-ds-open="ds-seletor-dialog"]')) etapa("tocou para abrir a gaveta"); }, true);
}
etapa("importando core");
const core = await window.ArpineDS.importar("core");
etapa("core ok; importando garagem");
const { garagem, marcarFiltroColecao } = await window.ArpineDS.importar("garagem");
etapa("garagem ok");
const cfg = window.ArpineDS;
const FORA_TXT = "Meu veículo não está na lista";

let dados = null;
let pedido = null;
function carregarDados() {
  if (dados) return Promise.resolve(dados);
  if (!pedido) {
    pedido = fetch(cfg.dataset)
      .then((r) => {
        if (!r.ok) throw new Error(`HTTP ${r.status}`);
        return r.json();
      })
      .then((json) => {
        dados = json;
        return json;
      })
      .catch((e) => {
        pedido = null;
        throw e;
      });
  }
  return pedido;
}

function opcoes(select, itens, vazio, comFora) {
  const lista = [new Option(vazio, "")];
  for (const it of itens) lista.push(new Option(it, it));
  if (comFora) lista.push(new Option(FORA_TXT, core.FORA));
  select.replaceChildren(...lista);
  select.disabled = lista.length === 1;
}

class Seletor {
  constructor(form) {
    this.form = form;
    this.variant = form.dataset.variant;
    this.marca = form.querySelector("[data-marca]");
    this.modelo = form.querySelector("[data-modelo]");
    this.ano = form.querySelector("[data-ano]");
    this.anoWrap = form.querySelector("[data-ano-wrap]");
    this.go = form.querySelector("[data-go]");
    this.lista = form.querySelector("[data-lista]");
    this.erro = form.querySelector("[data-erro]");
    this.fora = form.querySelector("[data-fora]");
    this.pronto = false;

    const preparar = () => this.preparar();
    form.addEventListener("pointerenter", preparar);
    form.addEventListener("pointerover", preparar); // mouse já parado em cima quando a página carrega
    form.addEventListener("pointerdown", preparar);
    form.addEventListener("focusin", preparar);
    form.querySelector("[data-retry]")?.addEventListener("click", preparar);
    this.marca.addEventListener("change", () => this.aoMudarMarca());
    this.modelo.addEventListener("change", () => this.aoMudarModelo());
    this.ano.addEventListener("change", () => this.aoMudarAno());
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      this.irParaPagina();
    });
    form.querySelector("[data-fora-go]")?.addEventListener("click", () => this.enviarFora());
    form.querySelector("[data-fora-voltar]")?.addEventListener("click", () => this.mostrarLista());
    if (this.variant === "page") this.preparar();
    // faixa do desktop (visível logo de cara): carrega quando o navegador estiver ocioso
    if (this.variant === "strip" && window.matchMedia("(min-width: 990px)").matches) {
      if ("requestIdleCallback" in window) window.requestIdleCallback(preparar, { timeout: 4000 });
      else setTimeout(preparar, 1500);
    }
  }

  async preparar() {
    if (this.pronto) return;
    try {
      const d = await carregarDados();
      if (this.pronto) return;
      this.pronto = true;
      this.erro.hidden = true;
      opcoes(this.marca, core.marcas(d), "Marca", true);
      etapa(`${this.variant}: ${this.marca.options.length} opções na marca`);
    } catch (e) {
      etapa(`${this.variant}: dataset FALHOU: ${e?.message ?? e}`);
      console.error("[ds-seletor] falha ao carregar o dataset:", e);
      this.erro.hidden = false;
    }
  }

  aoMudarMarca() {
    const marca = this.marca.value;
    if (marca === core.FORA) {
      this.marca.value = "";
      this.aoMudarMarca();
      this.abrirFora({});
      return;
    }
    opcoes(this.modelo, marca ? core.modelos(dados, marca) : [], "Modelo", Boolean(marca));
    opcoes(this.ano, [], "Ano", false);
    this.anoWrap.hidden = false;
    this.go.disabled = true;
  }

  aoMudarModelo() {
    const marca = this.marca.value;
    const modelo = this.modelo.value;
    if (modelo === core.FORA) {
      this.modelo.value = "";
      this.aoMudarModelo();
      this.abrirFora({ marca });
      return;
    }
    const anos = modelo ? core.anos(dados, marca, modelo) : [];
    if (modelo && anos.length === 0) {
      opcoes(this.ano, [], "Ano", false);
      this.anoWrap.hidden = true; // modelo sem anos: pula o passo do ano
      this.go.disabled = false;
    } else {
      this.anoWrap.hidden = false;
      opcoes(this.ano, anos, "Ano", Boolean(modelo));
      this.go.disabled = true;
    }
  }

  aoMudarAno() {
    if (this.ano.value === core.FORA) {
      this.ano.value = "";
      this.go.disabled = true;
      this.abrirFora({ marca: this.marca.value, modelo: this.modelo.value });
      return;
    }
    this.go.disabled = !this.ano.value;
  }

  irParaPagina() {
    if (this.go.disabled) return;
    const marca = this.marca.value;
    const modelo = this.modelo.value;
    const v = core.normalizeVehicle({
      marca,
      modelo,
      ano: this.anoWrap.hidden ? "" : this.ano.value,
      tipo: core.tipoDe(dados, marca, modelo),
      noCatalogo: true,
    });
    if (!v) return;
    // destino "colecao": filtra a coleção aberta em vez de sair dela, para quem entrou
    // pela categoria não perder a categoria. collectionRedirectUrl já existe e tem teste;
    // ela devolve null quando a URL já tem algum filter.*, e aí caímos na página do
    // veículo em vez de não navegar pra lugar nenhum.
    if (this.form.dataset.destino === "colecao") {
      const url = core.collectionRedirectUrl(location.pathname, location.search, v);
      if (url) {
        // GRAVAR NA GARAGEM é obrigatório aqui: antes do B3 todo caminho do seletor passava pela
        // página do veículo, que grava. Este atalho não passa — sem esta linha quem escolhe o veículo
        // no topo da coleção não ganha selo no card, não ganha o selo de encaixe na PDP, o site
        // esquece o veículo na página seguinte e, se já houver outro veículo salvo, a página fica
        // filtrada por um e o resto do site fala de outro.
        garagem.adicionar(v);
        // E marcar a chave de sessão do par caminho+veículo: o auto-filtro do ds-colecao-veiculo.js
        // re-filtraria a coleção no próximo carregamento, então o "✕ limpar" devolveria a página
        // filtrada de novo. Mesma função que ele usa (ds-garagem.js), não uma cópia da regra.
        marcarFiltroColecao(v);
        window.location.href = url;
        return;
      }
      // URL já filtrada: a página do veículo assume (e ela grava na garagem sozinha).
    }
    window.location.href = core.vehiclePageUrl(cfg.vehiclePage, v);
  }

  abrirFora(pref) {
    if (!this.fora) {
      // faixa do desktop: o formulário mora na gaveta do seletor
      document.dispatchEvent(new CustomEvent("arpine:seletor-fora", { detail: pref }));
      return;
    }
    this.mostrarFora(pref);
  }

  mostrarFora(pref = {}) {
    this.fora.querySelector("[data-fora-marca]").value = pref.marca ?? "";
    this.fora.querySelector("[data-fora-modelo]").value = pref.modelo ?? "";
    this.fora.querySelector("[data-fora-ano]").value = "";
    // marca e modelo conhecidos (ex.: o ano não está na lista): o tipo já vem marcado pelo dataset
    if (pref.marca && pref.modelo && dados) {
      const tipo = core.tipoDe(dados, pref.marca, pref.modelo);
      const radio = this.form.querySelector(`input[name="tipo"][value="${tipo}"]`);
      if (radio) radio.checked = true;
    }
    this.lista.hidden = true;
    this.fora.hidden = false;
    this.fora.querySelector(pref.marca ? "[data-fora-modelo]" : "[data-fora-marca]").focus();
  }

  mostrarLista() {
    this.fora.hidden = true;
    this.lista.hidden = false;
    this.marca.focus();
  }

  enviarFora() {
    const v = core.normalizeVehicle({
      marca: this.fora.querySelector("[data-fora-marca]").value,
      modelo: this.fora.querySelector("[data-fora-modelo]").value,
      ano: this.fora.querySelector("[data-fora-ano]").value,
      tipo: this.form.querySelector('input[name="tipo"]:checked')?.value,
      noCatalogo: false,
    });
    const erro = this.fora.querySelector("[data-fora-erro]");
    if (!v) {
      erro.hidden = false;
      return;
    }
    erro.hidden = true;
    window.location.href = core.vehiclePageUrl(cfg.vehiclePage, v);
  }
}

const seletores = [...document.querySelectorAll("[data-ds-seletor]")].map((f) => new Seletor(f));
etapa(`${seletores.length} seletor(es) ligados: ${seletores.map((s) => s.variant).join(", ")}`);

// Quem abre a gaveta do seletor (linha do celular, "Meu veículo", "trocar veículo") já carrega a lista.
document.addEventListener(
  "click",
  (e) => {
    if (e.target.closest?.('[data-ds-open="ds-seletor-dialog"], [data-ds-meu-veiculo]')) seletores.forEach((s) => s.preparar());
  },
  true
);

// A faixa do desktop pediu o formulário "fora do catálogo": abre a gaveta direto nele.
document.addEventListener("arpine:seletor-fora", (e) => {
  const gaveta = seletores.find((s) => s.variant === "sheet");
  if (!gaveta) return;
  window.ArpineDrawer?.abrir("ds-seletor-dialog");
  gaveta.preparar();
  gaveta.mostrarFora(e.detail ?? {});
});
